import { render, staticRenderFns } from "./currency_selection.vue?vue&type=template&id=34b5c109&"
import script from "./currency_selection.vue?vue&type=script&lang=js&"
export * from "./currency_selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports